import React from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./utils/dayjs";
import "antd/dist/reset.css";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import { history } from "./helpers/history";
import { Router } from "react-router-dom";
import { store } from "./redux";
import ErrorBoundary from "./components/ErrorBoundary";
import AppProviders from "./providers/AppProviders";
import config from "./config";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID || ''}>
      <Provider store={store}>
        <Router history={history}>
          <AppProviders>
            <App />
          </AppProviders>
        </Router>
      </Provider>
    </GoogleOAuthProvider>
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
